export const DB_CONFIG = {
    apiKey: "AIzaSyBqecYCj0jeUQx5YEwiAabJW3R58P4PAiw",
    authDomain: "reactnotesapp-25780.firebaseapp.com",
    databaseURL: "https://reactnotesapp-25780.firebaseio.com",
    projectId: "reactnotesapp-25780",
    storageBucket: "reactnotesapp-25780.appspot.com",
    messagingSenderId: "944096623355",
    appId: "1:944096623355:web:84713ecf3904450b"
}